export default __webpack_public_path__ + "static/media/careersocius.733295a4.jpg";